import {
  CRM_REMOVAL_STORE_EVENT_NAMES,
  CRM_SYNC_STORE_EVENT_NAMES,
  type CrmRemovalStoreEventName,
  type CrmSyncStoreEventName,
} from './store-events.types';

const CRM_SYNC_STORE_EVENT_NAME_SET = new Set<string>(CRM_SYNC_STORE_EVENT_NAMES);
const CRM_REMOVAL_STORE_EVENT_NAME_SET = new Set<string>(CRM_REMOVAL_STORE_EVENT_NAMES);

export function isCrmSyncStoreEventName(name: string): name is CrmSyncStoreEventName {
  return CRM_SYNC_STORE_EVENT_NAME_SET.has(name);
}

export function isCrmRemovalStoreEventName(name: string): name is CrmRemovalStoreEventName {
  return CRM_REMOVAL_STORE_EVENT_NAME_SET.has(name);
}
